import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";
import PinitComponent from "../pinitComponent";

export class BlogImageSwiper {
  private readonly swiperDiv: HTMLDivElement;
  private readonly numberOfSlides: number;
  private readonly swiper: Swiper;
  private readonly swParams: any;

  constructor(swiperDiv: HTMLDivElement) {
    this.swiperDiv = swiperDiv;
    this.numberOfSlides = swiperDiv.querySelectorAll(".swiper-slide").length;
    this.swParams = this.initParams();
    this.swiper = new Swiper(this.swiperDiv, this.swParams);
    this.swiper.loaded = true;
    this.callbackObserverUpdate();
  }

  /**
   * Breakpoints for alternating coverflow settings
   */
  private initBreakpoints() {
    const one = this.numberOfSlides > 1;
    const three = this.numberOfSlides >= 3;

    return {
      480: {
        allowSlideNext: one,
        allowSlidePrev: one,
        allowTouchMove: one,
        coverflowEffect: {
          stretch: -74,
        },
        slidesPerView: 1,
      },
      767: {
        allowSlideNext: three,
        allowSlidePrev: three,
        allowTouchMove: three,
        coverflowEffect: {
          stretch: -65,
        },
        slidesPerView: 2.5,
      },
      940: {
        allowSlideNext: three,
        allowSlidePrev: three,
        allowTouchMove: three,
        coverflowEffect: {
          stretch: -70,
        },
        slidesPerView: 2.5,
      },
      1119: {
        allowSlideNext: three,
        allowSlidePrev: three,
        allowTouchMove: three,
        coverflowEffect: {
          stretch: -94,
        },
        slidesPerView: 2.5,
      },
    };
  }

  /**
   * Hides swiper navigation, when number of slides beyond slots/columns shown
   */
  private callbackObserverUpdate() {
    const nav = this.swiper.navigation;
    const pag = this.swiper.pagination;
    const spv = this.swiper.params.slidesPerView;

    if (typeof spv === "number" && nav !== undefined && pag !== undefined) {
      if (this.numberOfSlides < Math.ceil(spv)) {
        nav.nextEl.classList.add("hide");
        nav.prevEl.classList.add("hide");
        pag.el.classList.add("hide");
      } else {
        nav.nextEl.classList.remove("hide");
        nav.prevEl.classList.remove("hide");
        pag.el.classList.remove("hide");
      }
    }
  }

  /**
   * Swiper params
   */
  private initParams() {
    const three = this.numberOfSlides >= 3;

    return {
      allowSlideNext: three,
      allowSlidePrev: three,
      allowTouchMove: three,
      breakpoints: this.initBreakpoints(),
      centeredSlides: true,
      coverflowEffect: {
        depth: 450,
        rotate: 0,
        slideShadows: false,
        stretch: -98,
      },
      effect: "coverflow",
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true,
      on: {
        init,
        lazyImageReady: (slide, image) => {
          PinitComponent.pinit(image, {minHeight: 5, minWidth: 5});
        },
        observerUpdate: this.callbackObserverUpdate.bind(this),
        slideChange,
      },
      pagination: {
        clickable: true,
        el: ".swiper-pagination-blog-images",
        type: "bullets",
      },
      preloadImages: false,
      simulateTouch: false,
      slidesPerView: 2.5,
    };
  }
}

function init() {
  Array.from<HTMLDivElement>(this.slides).forEach((slide) => {
    const anchor = slide.querySelector("a:not(.pin-it)");
    if (anchor !== null) {
      anchor.addEventListener("click", () => {
        Tracking.sendEvent("BlogEntry.ImageSwiper.Slide.Clicked");
      });
    }
  });
}

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("BlogEntry.ImageSwiper.Swiped");
  }
}
